import EventEmitter from 'eventemitter3';

export enum CLIP_CREATOR_EVENTS {
    STOP_PREVIEW = 'STOP_PREVIEW',
    SEEK_PREVIEW = 'SEEK_PREVIEW',
}
export type SeekPreviewPayload = {
    seekTimeMillis: number;
};
const ClipCreatorEventEmitter = new EventEmitter();
export default ClipCreatorEventEmitter;
